var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("基本信息")]),
        _vm._v(" "),
        _vm.servcWorkVoucher.servcType == 1 && _vm.servcWorkVoucher.suitFlag
          ? _c(
              "a",
              {
                staticClass: "swb-btn-link ml5",
                on: {
                  click: function($event) {
                    _vm.showDevcMaintInfo(_vm.servcWorkVoucher.id)
                  }
                }
              },
              [_vm._v("查看保养信息")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.servcWorkVoucher.servcType == 6
          ? _c(
              "a",
              {
                staticClass: "swb-btn-link ml5",
                on: {
                  click: function($event) {
                    _vm.showDevcInspectInfo(_vm.servcWorkVoucher.id)
                  }
                }
              },
              [_vm._v("查看检验信息")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "swb-btn-link ml5 fr",
            on: {
              click: function($event) {
                _vm.openWorkVoucherPdfDlg(_vm.servcWorkVoucher.id)
              }
            }
          },
          [_vm._v("打印")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "simple-form flex col-4" },
        [
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [_vm._v("工单编号")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c("span", [_vm._v(_vm._s(_vm.servcWorkVoucher.no))]),
                _vm._v(" "),
                _vm.servcWorkVoucher.comnRepairFlag &&
                !_vm.servcWorkVoucher.deviceFlag
                  ? _c("el-tag", { attrs: { type: "success" } }, [
                      _vm._v("日常维修")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.servcWorkVoucher.servcType != null
                  ? _c("el-tag", { attrs: { type: "success" } }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.workServcTypeMap[_vm.servcWorkVoucher.servcType]
                          )
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.servcWorkVoucher.remoted
                  ? _c("el-tag", { attrs: { type: "success" } }, [
                      _vm._v("远程解决")
                    ])
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [_vm._v("是否委托")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _vm.servcWorkVoucher.dlgtFlag
                ? _c("span", { staticClass: "swb-tags swb-tags-danger" }, [
                    _vm._v("委托")
                  ])
                : _c("span", { staticClass: "swb-tags" }, [_vm._v("否 ")])
            ])
          ]),
          _vm._v(" "),
          _vm.servcWorkVoucher.dlgtFlag
            ? [
                _vm.servcWorkVoucher.servcType == _vm.inspectValue
                  ? _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _vm._v("约检完成")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm.servcWorkVoucher.dlgtInspectFinished
                          ? _c(
                              "span",
                              { staticClass: "swb-tags swb-tags-success" },
                              [_vm._v("约检完成")]
                            )
                          : _vm._e()
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.servcWorkVoucher.servcType == _vm.inspectValue
                  ? _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _vm._v("约检完成时间")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm.servcWorkVoucher.dlgtInspectFinishTime != null
                          ? _c(
                              "span",
                              { staticClass: "swb-tags swb-tags-success" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.servcWorkVoucher.dlgtInspectFinishTime
                                  )
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.servcWorkVoucher.servcType == _vm.maintValue ||
                _vm.servcWorkVoucher.dlgtInspectFinished
                  ? _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _vm._v("约保完成")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm.servcWorkVoucher.dlgtMaintFinished
                          ? _c(
                              "span",
                              { staticClass: "swb-tags swb-tags-success" },
                              [_vm._v("约保完成")]
                            )
                          : _vm._e()
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.servcWorkVoucher.servcType == _vm.maintValue ||
                _vm.servcWorkVoucher.dlgtInspectFinished
                  ? _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _vm._v("约保完成时间")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm.servcWorkVoucher.dlgtMaintFinishTime != null
                          ? _c(
                              "span",
                              { staticClass: "swb-tags swb-tags-success" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.servcWorkVoucher.dlgtMaintFinishTime
                                  )
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [_vm._v("工单来源")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _vm.servcWorkVoucher.srcFlag != 0
                ? _c("span", { staticClass: "swb-tags swb-tags-success" }, [
                    _vm._v(
                      _vm._s(
                        _vm.servcWorkSrcFlagMap[_vm.servcWorkVoucher.srcFlag]
                      )
                    )
                  ])
                : _c("span", [_vm._v("无")])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [_vm._v("交易单号")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.servcWorkVoucher.tradeNo || ""))])
            ])
          ]),
          _vm._v(" "),
          _vm.servcWorkVoucher.devcPartName != null
            ? _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [_vm._v("维修部件")]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.servcWorkVoucher.devcPartName || ""))
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [_vm._v("紧急状态")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _vm.servcWorkVoucher.emgLevel == 0
                ? _c("span", { staticClass: "font-green mr20" }, [
                    _vm._v(
                      _vm._s(_vm.emgLevelMap[_vm.servcWorkVoucher.emgLevel])
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.servcWorkVoucher.emgLevel == 1
                ? _c("span", { staticClass: "font-orange mr20" }, [
                    _vm._v(
                      _vm._s(_vm.emgLevelMap[_vm.servcWorkVoucher.emgLevel])
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.servcWorkVoucher.emgLevel == 2
                ? _c("span", { staticClass: "font-red mr20" }, [
                    _vm._v(
                      _vm._s(_vm.emgLevelMap[_vm.servcWorkVoucher.emgLevel])
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [_vm._v("工单模式")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.servcWorkVoucher.grabFlag &&
                      _vm.servcWorkVoucher.grabIssuerType == 3
                      ? "抢单"
                      : "指派"
                  )
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [_vm._v("工单状态")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _vm.servcWorkVoucher.closed
                  ? _c("label", { staticClass: "mr20 font-red" }, [
                      _vm._v("已关闭")
                    ])
                  : _vm.servcWorkVoucher.invalid
                  ? _c("label", { staticClass: "mr20 font-red" }, [
                      _vm._v("已作废")
                    ])
                  : _vm.servcWorkVoucher.grabFlag &&
                    _vm.servcWorkVoucher.grabIssuerType == 3 &&
                    _vm.servcWorkVoucher.engineerId == null
                  ? _c("label", { staticClass: "mr20 font-red" }, [
                      _vm._v("抢单中")
                    ])
                  : _c("label", { staticClass: "mr20" }, [
                      _vm._v(_vm._s(_vm.servcWorkVoucher.stateText))
                    ]),
                _vm._v(" "),
                _vm.servcWorkVoucher.stateText == "服务暂停"
                  ? _c("label", { staticClass: "font-red" }, [
                      _vm._v(",原因：" + _vm._s(_vm.servcWorkVoucher.stateDesc))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.servcWorkVoucher.evalFlag
                  ? _c("el-tag", { attrs: { type: "success" } }, [
                      _vm._v("已评价")
                    ])
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.servcWorkVoucher.reqVoucherId != null &&
          _vm.servcWorkVoucher.reqVoucherId != -1
            ? _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _vm._v("请求单编号")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.servcWorkVoucher.reqVoucherNo))
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.servcWorkVoucher.reqVoucherId != null &&
          _vm.servcWorkVoucher.reqVoucherId != -1
            ? _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [_vm._v("请求时间")]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.servcWorkVoucher.requestTime))
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [_vm._v("工单截止时间")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("label", [_vm._v(_vm._s(_vm.servcWorkVoucher.yqFinishTime))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [_vm._v("工单创建时间")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("label", [_vm._v(_vm._s(_vm.servcWorkVoucher.createTime))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [_vm._v("工单创建人")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("label", [_vm._v(_vm._s(_vm.servcWorkVoucher.creatorName))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [_vm._v("指派网点")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _vm.servcWorkVoucher.servicerShopId == null
                ? _c("label", [_vm._v("未指派")])
                : _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.servcWorkVoucher.manualShopFlag ? "手工" : "自动"
                      )
                    )
                  ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [_vm._v("指派工程师")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _vm.servcWorkVoucher.engineerId == null
                ? _c("label", [_vm._v("未指派")])
                : _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.servcWorkVoucher.manualEngFlag ? "手工" : "自动"
                      )
                    )
                  ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _vm._v("是否约定期保外")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _vm.servcWorkVoucher.beyondWrnt
                  ? _c("el-tag", { attrs: { type: "danger" } }, [
                      _vm._v("交易约定外")
                    ])
                  : _c("el-tag", { attrs: { type: "success" } }, [
                      _vm._v("交易约定内")
                    ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [_vm._v("仅报修人验收")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _vm.servcWorkVoucher.acceptByRequester
                ? _c("span", [_vm._v("是")])
                : _vm._e(),
              _vm._v(" "),
              !_vm.servcWorkVoucher.acceptByRequester
                ? _c("span", [_vm._v("否")])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [_vm._v("业务标签")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              _vm._l(_vm.servcWorkVoucher.tagNames, function(tagName) {
                return _vm.servcWorkVoucher.hasTag
                  ? _c("span", [
                      _c(
                        "span",
                        { staticClass: "swb-tags swb-tags-success mr5" },
                        [_vm._v(_vm._s(tagName))]
                      )
                    ])
                  : _c(
                      "span",
                      { staticClass: "swb-tags swb-tags-success mr5" },
                      [_vm._v(_vm._s(_vm.servcWorkVoucher.retailerTag))]
                    )
              })
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [_vm._v("是否异常")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.servcWorkVoucher.abnormal ? "是" : "否"))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [_vm._v("异常原因")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.servcWorkVoucher.abnormalDesc || ""))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [_vm._v("是否无效")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.servcWorkVoucher.invain ? "是" : "否"))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [_vm._v("违约状态")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _vm.servcWorkVoucher.violated
                ? _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.servcWorkVoucher.violateState == 0
                          ? "违约(已处理)"
                          : "违约(未处理)"
                      )
                    )
                  ])
                : _c("label", [_vm._v("未违约")])
            ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _vm.servcWorkVoucher.servcType == 2 &&
      _vm.servcWorkVoucher.devcSetupInfo != null &&
      _vm.servcWorkVoucher.devcSetupInfo.devcSetupItemList != null &&
      _vm.servcWorkVoucher.devcSetupInfo.devcSetupItemList.length > 0
        ? _c("div", [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-layout" },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data:
                        _vm.servcWorkVoucher.devcSetupInfo.devcSetupItemList,
                      border: ""
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "devcXN",
                        label: "设备编号",
                        align: "left",
                        width: "220"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "shopDeviceSvcSubNo.vendorUkno",
                        label: "商品标识码",
                        align: "left",
                        width: "220"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "shopDeviceSvcSubNo.sellerName",
                        label: "卖家名称",
                        align: "left",
                        width: "220"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "extraInfo",
                        label: "其他信息",
                        align: "left"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "asmblFlag",
                        label: "含组装商品",
                        width: "150",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(rows.row.asmblFlag ? "是" : "否"))
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "asmblDone",
                        label: "是否组装完成",
                        width: "150",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.asmblFlag
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(rows.row.asmblDone ? "是" : "否")
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "asmblWhileSetup",
                        label: "安装时完成组装",
                        width: "150",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(rows.row.asmblWhileSetup ? "是" : "否")
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { align: "center", width: "80", label: "操作" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.asmblFlag
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "swb-btn-link",
                                      on: {
                                        click: function($event) {
                                          _vm.showAsmblInfo(rows.row.devcId)
                                        }
                                      }
                                    },
                                    [_vm._v("组装信息")]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm.servcWorkVoucher.servcOrderItemList != null
        ? _c(
            "div",
            { staticClass: "table-layout" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.servcWorkVoucher.servcOrderItemList,
                    border: ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "title",
                      label: "服务名称",
                      width: "260",
                      align: "left"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "catName",
                      label: "服务分类",
                      width: "180",
                      align: "left"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "amount",
                      label: "价格(元)",
                      width: "180",
                      align: "right"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "", label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.toChargeItems(
                                      _vm.servcWorkVoucher.id,
                                      rows.row.id
                                    )
                                  }
                                }
                              },
                              [_vm._v("查看收费项")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "simple-form flex col-4" },
        [
          _vm.servcWorkVoucher.devcVendorSn != null
            ? [
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _vm._v("厂商序列号")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.servcWorkVoucher.devcVendorSn || "无"))
                    ])
                  ])
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.servcWorkVoucher.deviceFlag
            ? [
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _vm._v("系统编号")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.servcWorkVoucher.tmpNo || "无"))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _vm._v("商品标识码")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.servcWorkVoucher.vendorUkno || "无"))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _vm._v("设备名称")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.servcWorkVoucher.deviceName || "无"))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _vm._v("设备分类")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.servcWorkVoucher.deviceCatName || "无"))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _vm._v("维保分组")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.servcWorkVoucher.devcGroupFullName || "无")
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _vm._v("设备品牌")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.servcWorkVoucher.deviceBrandName || "无")
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _vm._v("所在部门")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.servcWorkVoucher.departName || "无"))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _vm._v("位置编码")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.servcWorkVoucher.devcLocCode))
                    ])
                  ])
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.servcWorkVoucher.servcWorkDeviceParts != null
            ? _c(
                "div",
                { staticClass: "form-group center" },
                [
                  _c("div", { staticClass: "form-label" }, [
                    _vm._v("部件名称")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.servcWorkVoucher.servcWorkDeviceParts, function(
                    servcWorkDevicePart,
                    index
                  ) {
                    return _c("div", { staticClass: "form-value" }, [
                      _c("label", [
                        _vm._v(_vm._s(servcWorkDevicePart.partName))
                      ])
                    ])
                  })
                ],
                2
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.servcWorkVoucher.servcWorkAccItemList != null &&
      _vm.servcWorkVoucher.servcWorkAccItemList.length > 0
        ? _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("配件信息")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.servcWorkAccItemList != null &&
      _vm.servcWorkVoucher.servcWorkAccItemList.length > 0
        ? _c(
            "div",
            { staticClass: "table-layout" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.servcWorkVoucher.servcWorkAccItemList,
                    border: ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "accName",
                      label: "配件名称",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "quantity",
                      label: "个数",
                      width: "60",
                      align: "right"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "unit",
                      label: "单位",
                      width: "60",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "shareAccFlag",
                      label: "自用",
                      width: "80",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.shareAccFlag
                              ? _c(
                                  "span",
                                  { staticStyle: { color: "green" } },
                                  [_vm._v("是")]
                                )
                              : _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("否")
                                ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "mountFlag",
                      label: "拆卸标记",
                      width: "80",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.mountFlag == 1
                              ? _c(
                                  "span",
                                  { staticStyle: { color: "green" } },
                                  [_vm._v("换上")]
                                )
                              : _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("换下")
                                ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "vendorSn",
                      label: "厂商序列号",
                      width: "140",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "replaceFlag",
                      label: "更换信息",
                      width: "140",
                      align: "left",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                "\n                        更换了" +
                                  _vm._s(scope.row.replacedVendorSn) +
                                  "\n                    "
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "replaceDesc",
                      label: "更换说明",
                      width: "160",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "price",
                      label: "单价(元)",
                      width: "80",
                      align: "right"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "amount",
                      label: "价格(元)",
                      width: "80",
                      align: "right"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "accClaim.price",
                      label: "要求价格下限(元)",
                      width: "120",
                      align: "right"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "accClaim.price2",
                      label: "要求价格上限(元)",
                      width: "120",
                      align: "right"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "metFlag",
                      label: "要求是否满足",
                      width: "110",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.refAccClaimId != null &&
                            scope.row.refAccClaimId != -1 &&
                            !scope.row.shareAccFlag
                              ? _c("div", [
                                  scope.row.metFlag
                                    ? _c(
                                        "span",
                                        { staticStyle: { color: "green" } },
                                        [_vm._v("满足")]
                                      )
                                    : _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v("不满足")]
                                      )
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.spotImageUrl != null &&
      _vm.servcWorkVoucher.spotImageUrl.length > 0
        ? _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("现场图片")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.spotImageUrl != null &&
      _vm.servcWorkVoucher.spotImageUrl.length > 0
        ? _c("div", { staticClass: "file-item viewable image" }, [
            _c("img", {
              staticStyle: { width: "120px", height: "120px" },
              attrs: { src: _vm.servcWorkVoucher.spotImageUrl },
              on: {
                click: function($event) {
                  _vm.showImage(_vm.servcWorkVoucher.spotImageUrl)
                }
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.servcWorkRepairImgFileList != null &&
      _vm.servcWorkVoucher.servcWorkRepairImgFileList.length > 0
        ? _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.servcWorkVoucher.servcType == 2 ? "安装" : "问题") +
                  "图片"
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.servcWorkRepairImgFileList != null &&
      _vm.servcWorkVoucher.servcWorkRepairImgFileList.length > 0
        ? _c(
            "div",
            { staticClass: "file-item viewable image" },
            _vm._l(_vm.servcWorkVoucher.servcWorkRepairImgFileList, function(
              servcWorkImgFile
            ) {
              return _c("img", {
                staticStyle: { width: "120px", height: "120px" },
                attrs: { src: servcWorkImgFile.fileBrowseUrl },
                on: {
                  click: function($event) {
                    _vm.showImage(servcWorkImgFile.fileBrowseUrl)
                  }
                }
              })
            })
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.servcWorkImgFileList != null &&
      _vm.servcWorkVoucher.servcWorkImgFileList.length > 0
        ? _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("完成图片")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.servcWorkImgFileList != null &&
      _vm.servcWorkVoucher.servcWorkImgFileList.length > 0
        ? _c(
            "div",
            { staticClass: "file-item viewable image" },
            _vm._l(_vm.servcWorkVoucher.servcWorkImgFileList, function(
              servcWorkImgFile
            ) {
              return _c("img", {
                staticStyle: { width: "120px", height: "120px" },
                attrs: { src: servcWorkImgFile.fileBrowseUrl },
                on: {
                  click: function($event) {
                    _vm.showImage(servcWorkImgFile.fileBrowseUrl)
                  }
                }
              })
            })
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption bg-white dashed" }, [
        _c("span", [_vm._v("费用信息")]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "fr", staticStyle: { "font-style": "12px" } },
          [_vm._v("总费用(元)：" + _vm._s(_vm.servcWorkVoucher.amount))]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-4" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("是否免费")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _vm.servcWorkVoucher.freeFlag
              ? _c("span", { staticClass: "swb-tags swb-tags-success" }, [
                  _vm._v("免费")
                ])
              : _c("span", { staticClass: "swb-tags swb-tags-danger" }, [
                  _vm._v("收费")
                ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("上门费(元)")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("label", [
              _vm._v(
                _vm._s(
                  _vm.servcWorkVoucher.toDoorFee == null
                    ? "无"
                    : _vm.servcWorkVoucher.toDoorFee
                )
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("服务费(元)")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("label", [
              _vm._v(
                _vm._s(
                  _vm.servcWorkVoucher.generallFee == null
                    ? "无"
                    : _vm.servcWorkVoucher.generallFee
                )
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("配件费(元)")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("label", [
              _vm._v(
                _vm._s(
                  _vm.servcWorkVoucher.accFee == null
                    ? "无"
                    : _vm.servcWorkVoucher.accFee
                )
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.servcWorkVoucher.srcVendorId != null &&
      _vm.servcWorkVoucher.srcVendorId != -1
        ? _c("div", [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form" }, [
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _vm._v("供应商名称")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.servcWorkVoucher.srcVendorName))
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-4" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("服务请求方")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("label", [_vm._v(_vm._s(_vm.servcWorkVoucher.buyerName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("业务单元")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("label", [_vm._v(_vm._s(_vm.servcWorkVoucher.buyerBizUnitName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("请求部门")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("label", [_vm._v(_vm._s(_vm.servcWorkVoucher.buyerShopName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("请求机构编号")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.servcWorkVoucher.buyerShopNo || ""))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("请求人")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.servcWorkVoucher.requesterStaffName))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("请求人电话")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.servcWorkVoucher.requesterContactTel))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("请求地址")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("label", [_vm._v(_vm._s(_vm.servcWorkVoucher.buyerShopAddr))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _vm._v("请求机构联系电话")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.servcWorkVoucher.buyerShopContactTel))
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.servcWorkVoucher.reqVoucherId != null &&
        _vm.servcWorkVoucher.reqVoucherId != -1
          ? _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [_vm._v("请求描述")]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.servcWorkVoucher.requestDesc || "无"))
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.servcWorkVoucher.troubleDesc != null
          ? _c("div", { staticClass: "form-group center" }, [
              _vm.servcWorkVoucher.servcType == 2
                ? _c("div", { staticClass: "form-label" }, [_vm._v("安装说明")])
                : _vm.servcWorkVoucher.servcType == 3 ||
                  _vm.servcWorkVoucher.servcType == 5
                ? _c("div", { staticClass: "form-label" }, [_vm._v("描述")])
                : _c("div", { staticClass: "form-label" }, [
                    _vm._v("情况描述")
                  ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.servcWorkVoucher.troubleDesc || "无"))
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("预约上门时间")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.servcWorkVoucher.planTime || "无"))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("要求响应时长")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.servcWorkVoucher.yqRspTimeMi || "无"))
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("(分钟)")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("要求到达时长")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.servcWorkVoucher.yqArriveTimeMi || "无"))
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("(分钟)")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("要求完成时长")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.servcWorkVoucher.yqRepairedTimeMi || "无"))
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("(分钟)")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("要求回询时限")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.servcWorkVoucher.reqTelCallTimeMi || "无"))
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("(分钟)")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("计划出发时间")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.servcWorkVoucher.planStartOffTime || "无"))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("预计完成时间")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.servcWorkVoucher.estiFinishTime || "无"))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("实际响应时长")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.servcWorkVoucher.rspTimeMi == null
                    ? "无"
                    : _vm.servcWorkVoucher.rspTimeMi
                )
              )
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("(分钟)")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("实际到达时长")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.servcWorkVoucher.arriveTimeMi == null
                    ? "无"
                    : _vm.servcWorkVoucher.arriveTimeMi
                )
              )
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("(分钟)")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("实际完成时长")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.servcWorkVoucher.repairedTimeMi == null
                    ? "无"
                    : _vm.servcWorkVoucher.repairedTimeMi
                )
              )
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("(分钟)")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("实际回询时限")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.servcWorkVoucher.rspTelCallTimeMi == null
                    ? "无"
                    : _vm.servcWorkVoucher.rspTelCallTimeMi
                )
              )
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("(分钟)")])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-4" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("服务商名称")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("label", [_vm._v(_vm._s(_vm.servcWorkVoucher.servicerName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("服务网点名称")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("label", [_vm._v(_vm._s(_vm.servcWorkVoucher.servicerShopName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("网点联系电话")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("label", [
              _vm._v(
                _vm._s(_vm.servcWorkVoucher.servicerShopContractTel || "无")
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("网点联系人")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("label", [
              _vm._v(
                _vm._s(_vm.servcWorkVoucher.servicerShopContractName || "无")
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("工程师信息")]),
        _vm._v(" "),
        _vm.servcWorkVoucher.qualiClaimFlag
          ? _c(
              "a",
              {
                staticClass: "swb-btn-link ml5",
                on: {
                  click: function($event) {
                    _vm.showQualiClaim(_vm.servcWorkVoucher.id)
                  }
                }
              },
              [_vm._v("要求资质")]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-4" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("主工程师")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.servcWorkVoucher.engineerName || "无"))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("辅助工程师")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.servcWorkVoucher.engineerNames || "无"))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _vm._v("主工程师联系电话")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.servcWorkVoucher.contactTel || "无"))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [_vm._v("到达时间")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.servcWorkVoucher.toDoorTime || "无"))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.servcWorkVoucher.contractId != null
        ? _c("div", [
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-4" }, [
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [_vm._v("合同号")]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("label", [_vm._v(_vm._s(_vm.servcWorkVoucher.contractNo))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _vm._v("原始合同号")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.servcWorkVoucher.contractOriginalNo))
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.tradeId != null
        ? _c("div", [
            _vm._m(6),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-4" }, [
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [_vm._v("交易单号")]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("label", [_vm._v(_vm._s(_vm.servcWorkVoucher.tradeNo))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [_vm._v("交易类型")]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(_vm.tradeTypeMap[_vm.servcWorkVoucher.tradeType])
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _vm._v("指标跟踪阶段")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(_vm.servcWorkVoucher.trackPhaseName || _vm.无)
                    )
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.finished
        ? _c("div", [
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-4" }, [
              _vm.servcWorkVoucher.reqVoucherId != null &&
              _vm.servcWorkVoucher.reqVoucherId != -1
                ? _c("div", { staticClass: "form-group center" }, [
                    _c("div", { staticClass: "form-label" }, [
                      _vm._v("故障类型")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.servcWorkVoucher.faultTypeName || "无")
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [_vm._v("故障描述")]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.servcWorkVoucher.faultDesc || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [_vm._v("维修类型")]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.servcWorkVoucher.repairTypeName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _vm._v("服务完成时间")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.servcWorkVoucher.finishTime || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [_vm._v("处理结果")]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.servcWorkVoucher.handleResult || "无"))
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(8),
      _vm._v(" "),
      _vm.servcWorkVoucher.id != null
        ? _c("swb-servc-work-voucher-rec-list", {
            attrs: { voucherId: _vm.servcWorkVoucher.id }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("安装信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("设备信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("供方信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("请求信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("服务网点信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("合同信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("交易信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("工单处理信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("工单操作记录")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a4d100bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4d100bc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/workVoucher/ServcWorkVoucherDetail.vue
// module id = 2759
// module chunks = 0